/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Diff_Faq_A6Inputs */

const en_diff_faq_a6 = /** @type {(inputs: Diff_Faq_A6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arrays are compared position by position, so shifting one element changes the value at every position after it. Each of those positions is reported. Sort both arrays by a stable key before comparing if you care about membership rather than order.`)
};

const ko_diff_faq_a6 = /** @type {(inputs: Diff_Faq_A6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`배열은 위치별로 비교되므로, 한 요소를 밀면 그 뒤의 모든 위치에서 값이 바뀝니다. 그 위치들이 각각 보고됩니다. 순서가 아니라 구성원이 중요하다면 비교 전에 안정적인 키로 양쪽 배열을 정렬하세요.`)
};

const ja_diff_faq_a6 = /** @type {(inputs: Diff_Faq_A6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`配列は位置ごとに比較されるため、1 要素をずらすとその後ろのすべての位置で値が変わります。その位置がそれぞれ報告されます。順序ではなく構成員が重要なら、比較の前に安定したキーで両方の配列を並べ替えてください。`)
};

/**
* | output |
* | --- |
* | "Arrays are compared position by position, so shifting one element changes the value at every position after it. Each of those positions is reported. Sort bot..." |
*
* @param {Diff_Faq_A6Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const diff_faq_a6 = /** @type {((inputs?: Diff_Faq_A6Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Diff_Faq_A6Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_diff_faq_a6(inputs)
	if (locale === "ko") return ko_diff_faq_a6(inputs)
	return ja_diff_faq_a6(inputs)
});